export default "__VITE_ASSET__BCPd1Q06__"